import React from 'react'
import MainLayout from './MainLayout'

const App:React.FC = () => (
    <MainLayout />
)

export default App
